import { ICONS } from 'Components/utils/icon/icons';

export const themes = {
  default: {
    thCapsuleContent: 'divide-y',
    thMessage: 'font-bold p-20 text-14',
    thCollapse: 'border-lightGrey',
    thCollapseTheme: 'limpidSmall',
    thCollapseIconCollapse: ICONS.ARROW_DOWN,
    thCollapseIconExpand: ICONS.ARROW_DOWN,
    thItems: 'pb-20 text-14',
    thItem: 'flex gap-15 items-center px-20 py-5',
    thItemIcon: 'shrink-0 text-sienna',
    thItemIconWidth: '1.5rem',
    thItemLabel: 'flex-1',
  },
};
